import { render, staticRenderFns } from "./aicenter.vue?vue&type=template&id=a124c2b4&scoped=true&"
import script from "./aicenter.vue?vue&type=script&lang=js&"
export * from "./aicenter.vue?vue&type=script&lang=js&"
import style0 from "./aicenter.vue?vue&type=style&index=0&id=a124c2b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a124c2b4",
  null
  
)

export default component.exports